import VoerroTagsInput from './VoerroTagsInput.vue'

window.VoerroTagsInput = VoerroTagsInput;

export default VoerroTagsInput;